module.exports = __webpack_public_path__ + "img/k12_2.bfc2f350.jpg";